import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/common/Navbar';
import LandingPage from './pages/LandingPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetail from './pages/ProductDetail';
import Dashboard from './pages/Dashboard';
import { LanguageProvider } from './store/languageContext';
import './App.css';
import { BrandsPage } from './components/dashboard/BrandsPage';
import { ContactRequestsPage } from './components/dashboard/ContactRequestsPage';
import { ProductsPage as DashboardProductsPage } from './components/dashboard/ProductsPage';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Register the module (do this once, e.g., in useEffect or globally)
ModuleRegistry.registerModules([AllCommunityModule]);
function App() {
  return (
    <Router>
      <LanguageProvider>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/dashboard" element={<Dashboard />}>
              <Route path="products" element={<DashboardProductsPage />} />
              <Route path="brands" element={<BrandsPage />} />
              <Route path="contact-requests" element={<ContactRequestsPage />} />
            </Route>
          </Routes>
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;